// extracted by mini-css-extract-plugin
export var sm = "768";
export var md = "1024";
export var lg = "1280";
export var xl = "1600";
export var wrapper = "TeamMemberCard-module--wrapper--ckfWt";
export var image = "TeamMemberCard-module--image--1ei1L";
export var rounded = "TeamMemberCard-module--rounded--JGLrQ";
export var name = "TeamMemberCard-module--name--UC3dJ";
export var position = "TeamMemberCard-module--position--zVHfq";
export var contact = "TeamMemberCard-module--contact--uAGg8";